import { DateTime } from 'luxon';
import { isValidDate } from '../isValidDate';
import { Variable } from '../../types';
import { formatMicroseconds } from '../../inputs/time-duration/formatMicroSeconds';
import { decodeURIComponentSafe } from 'helpers/generic';

export const backendValueToFormValue = ({
	value,
	variable
}: {
	value: any;
	variable: Variable;
}) => {
	switch (variable.variableType) {
		case 'date': {
			if (value === null || value === undefined) {
				return '';
			}

			if (typeof value === 'string' && isValidDate(value)) {
				return DateTime.fromISO(value).toFormat('yyyy-MM-dd');
			}

			console.error(new Error('Invalid date value'));

			return '';
		}

		case 'datetime': {
			if (value === null || value === undefined) {
				return '';
			}

			if (typeof value === 'string' && isValidDate(value)) {
				return DateTime.fromISO(value).toFormat("yyyy-MM-dd'T'HH:mm:ss");
			}

			console.error(new Error('Invalid date value'));

			return '';
		}
		case 'categoryMultiple': {
			if (
				value === null ||
				value === undefined ||
				value === '' ||
				// the backend allows us to create categories with value false when using non fixed categories, and for a brief period of time it was possible through a frontend bug, so we need this
				value === false
			) {
				return []; // we need to return an empty array to indicate to react hook form that we want to use empty array for noting selected
			}
			if (typeof value === 'string') {
				return [decodeURIComponentSafe(value)];
			}
			return value.map(decodeURIComponentSafe);
		}
		case 'category': {
			if (
				value === null ||
				value === undefined ||
				value === '' ||
				// the backend allows us to create categories with value false when using non fixed categories, and for a brief period of time it was possible through a frontend bug, so we need this
				value === false
			) {
				return '';
			}

			if (typeof value === 'number') {
				return value.toString();
			}

			if (typeof value !== 'string') {
				console.error(
					`Expected category value to be string or number, was ${typeof value}`
				);
				return '';
			}

			return decodeURIComponentSafe(value);
		}

		case 'file': {
			// not sure if null and undefined is needed here or if backend always gives empty string
			if (value === null || value === undefined || value === '') {
				return null;
			}

			return { type: 'backend-file', fileId: value };
		}

		case 'float':
		case 'integer':
		case 'string':
			if (value === null || value === undefined) {
				return '';
			}

			return value.toString();

		case 'timeDuration': {
			if (value === null || value === undefined || value === '') {
				return '';
			}

			return formatMicroseconds({
				microseconds: value,
				maxTimeUnit: variable.durationFormat.maxTimeUnit,
				minTimeUnit: variable.durationFormat.minTimeUnit
			});
		}

		default: {
			return value;
		}
	}
};
